import * as React from "react";

import "./Table.scss";

export const ElementTable = ({ data }) => {
    if (!data.length) {
        return <p>No data available</p>;
    }

    const headers = Object.keys(data[0]);

    return (
        <div className="table-responsive">
            <table className="table">
                <thead className="table-header">
                <tr>
                    {headers.map((header, index) => (
                        <th className="table-header-cell"key={index}>{header}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {data.map((row, rowIndex) => (
                    <tr className="table-row" key={rowIndex}>
                        {headers.map((header, index) => (
                            <td className="table-cell" key={index}>{row[header]}</td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};
